import { memo } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { selectVisiblePriceTypesByTicketType } from '%evp_ticket_frontend/js/redux/currentEvent';
import PriceSelector from './PriceSelector';

const style = ({ spacing }) => ({
    singleTitle: {
        paddingTop: spacing(1),
    },
    mobileTitle: {
        paddingRight: spacing(1),
    },
});

export default compose(
    connect(
        (state, { ticketTypeHash }) => ({
            priceTypes: selectVisiblePriceTypesByTicketType(state, ticketTypeHash),
        }),
    ),
    withStyles(style),
    memo,
)(PriceSelector);
